const tasks = (state = [], action) => {
    switch (action.type) {
        case 'LOAD_TASKS_SUCCESS':
        return action.payload.data;

        case 'CREATE_TASK_SUCCESS':
        return [
            ...state,
            {...action.payload.data.data}
        ];

        case 'SAVE_TASK_SUCCESS':
        return [
            ...state.map(item => item.id != action.payload.data.data.id? item : action.payload.data.data),
        ];

        case 'DELETE_TASK_SUCCESS':
        return [
            ...state.filter(item => item.id != action.meta.previousAction.id),
        ];
        
        default:
        return state
    }
}

export default tasks;